import React from 'react';
import cn from 'classnames'

const Spinner = ({ classes = [] }) =>
    {
    return (<div
        style={{
            position: "fixed",
            left: 0, top: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 9999,
            background: "rgba(255,255,255,1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}
        className={cn(classes)}
  >
    <svg width="80" height="80" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" stroke="#1976d2">
      <g fill="none" fillRule="evenodd" strokeWidth="3">
        <circle cx="22" cy="22" r="20" strokeOpacity=".5" />
        <path d="M42 22c0-11.046-8.954-20-20-20">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 22 22"
            to="360 22 22"
            dur="1s"
            repeatCount="indefinite" />
        </path>
      </g>
    </svg>
            </div>)
    }


export default Spinner;
